// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon_style_icon__1DIej"};